import { useQuery } from '@tanstack/react-query';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface MissingTimesheetsParams {
  year: number;
  weekId: number;
  showMyTeam: boolean;
}

/** @registry Users in an office with no (or incomplete) hours for a work week. */
export function useMissingTimesheets(
  officeId: number | null | undefined,
  params: MissingTimesheetsParams,
) {
  return useQuery({
    queryKey: queryKeys.timesheets.missing(officeId ?? -1, params),
    queryFn: ({ signal }) =>
      timesheetApiClient.getMissingTimesheetsForOffice(
        officeId!,
        params.year,
        params.weekId,
        { showMyTeam: params.showMyTeam },
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    meta: { errorContext: 'missing timesheets' },
  });
}
